import { render } from "./Overhead.vue?vue&type=template&id=6177df81&scoped=true"
import script from "./Overhead.vue?vue&type=script&lang=js"
export * from "./Overhead.vue?vue&type=script&lang=js"

import "./Overhead.vue?vue&type=style&index=0&id=6177df81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6177df81"]])

export default __exports__